<header>
  <div class="header-page justify-items-between align-items-center">
    <div class="col-12 d-flex px-0">
      <div class="col-2 logo pt-3 pb-3 px-0">
        <img
          class="bloom-icon"
          src="{{
            RESOURCE_SERVER_URL
          }}/assets/images/Header/Bloom_Insurance.jpg" alt="Logo Image"
        />
      </div>
      <div class="col-8 align_class d-flex ml-5">
        <div class="pl-5">
          <img
            src="{{ RESOURCE_SERVER_URL }}/assets/images/Header/Menu_Copy.svg"
            alt=""
          />
        </div>
        <div>
          <img
            class="search pl-2 iconsColors"
            src="{{ RESOURCE_SERVER_URL }}/assets/images/search.svg"
            alt="img search"
          />
          <div class="searchInput">
            <custom-input-text placeholder="{{ 'Search' }}">
            </custom-input-text>
          </div>
        </div>
        <div>
          <div class="col-2 profile-icon">
            <img
              src="{{
                RESOURCE_SERVER_URL +
                  '/assets/images/Underwriting_new/Header/Profile_top.svg'
              }}"
              alt=""
            />
          </div>
        </div>
        <hr />
      </div>
    </div>
  </div>
</header>
